import { useMutation } from "react-query";
import { addHierarchy } from "actions/CarrierAgreementMgmt/Hierarchy";

const useAddHierarchy = () => {
  return useMutation(addHierarchy);
};
export default useAddHierarchy;
